{
  "activity_start_time": "Hora de início da atividade",
  "type": {
    "type_of_start_time": "Tipo de horário de início",
    "relative": "Em relação à sessão/item agendado",
    "relative_description": "Exemplo: 2 minutos após o início da sessão ou 5 minutos após o último item agendado",
    "fixed": "Fixo",
    "fixed_description": "Exemplo: 09:00",
    "relative_time": "Tempo relativo",
    "fixed_time": "Horário fixo"
  },
  "start_activity": "Iniciar atividade",
  "preposition": {
    "before": "antes",
    "after": "depois"
  },
  "preposition_lables": {
    "before": "antes de {{ type }} começar",
    "after": "após {{ type }} começar"
  },
  "relative_to": {
    "start_time": "hora de início do",
    "end_time": "hora de término do",
    "zero_time": "tempo zero de"
  },
  "relationship": {
    "every": "cada",
    "specific": "específico",
    "first": "primeiro",
    "last": "último"
  },
  "related_type": {
    "Session": "sessão",
    "Scheduled item": "item agendado"
  },
  "repeat_activity": {
    "repeat_activity": "Repita a atividade",
    "repeat_on_all": "Repita nos dias (todos)",
    "none_selected": "Nenhum selecionado",
    "all_days": "Todos os dias"
  },
  "info": {
    "can_not_delete": "Não é possível excluir esse item da programação, pois ele é usado por outro item da programação"
  }
}